<template>
    <div class="news">
        <div class="title wow fadeInUp" @click="gotoNews">
            新闻资讯
        </div>
        <div class="content">
          <div class="left wow fadeInLeft" @click="gotoInfo(nInfo.id)">
              <img :src="`http://www.zrichhome.com/${nInfo.nImg}`" alt="">
              <div class="nInfo">
                 <p>—— {{nInfo.posttime | formatDate}}</p>
                  <p>{{nInfo.title}}</p>
                  <p v-html="nInfo.description"></p>
              </div>
              <div class="add">
                  <i class="el-icon-plus"></i>
              </div>
          </div>
            <div class="r wow fadeInRight">
                 <div class="one" v-for="(item,index) in list" :key="index" @click="gotoInfo(item.id)">
                     <img :src="`http://www.zrichhome.com/${item.picurl}`" alt="">
                <div class="ocon">
                 <p>{{item.posttime | formatDate}}</p>
                    <p v-html="item.title">
                    </p>
                </div>
                     <div class="add">
                         <i class="el-icon-plus"></i>
                     </div>
            </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {getProductsUrl,getHome} from '../util/lang'
    export default {
        name: "news",
        data(){
            return{
                nInfo:{},
                list:[]
            }
        },
        filters: {
            formatDate: function (value) {
                value=parseInt(value)*1000
                let date = new Date(value);
                let y = date.getFullYear();
                let MM = date.getMonth() + 1;
                MM = MM < 10 ? ('0' + MM) : MM;
                let d = date.getDate();
                d = d < 10 ? ('0' + d) : d;
                let h = date.getHours();
                h = h < 10 ? ('0' + h) : h;
                let m = date.getMinutes();
                m = m < 10 ? ('0' + m) : m;
                let s = date.getSeconds();
                s = s < 10 ? ('0' + s) : s;
                return y + '-' + MM + '-' + d + ' ' ;
            }
        },
        mounted(){
            this.$nextTick(()=>{
                this.getNews('26')
            })
        },
        methods:{
            gotoNews(){
                const  link='/news.html'
                window.open(link,'_self')
            },
            gotoInfo(id){
                const  link=`/newsInfo.html?id=${id}`;
                window.open(link,'_blank');
            },
            getNews(id){
                const url = `${getProductsUrl(id)}`
                this.$axios.get(url).then(res => {
                    res.data.data.map((item)=>{
                        if(item.flag=='h'){
                            this.list.push(item)
                        }
                    })
                    this.nInfo=this.list[0]
                    console.log(this.list)

                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.news{
    width:1440px;
    margin:0 auto;
    animation-duration: 2s;
    .title{
        width:140px;
        height:130px;
        background:rgba(51,49,55,1);
        text-align: center;
        line-height: 130px;
        color:white;
        margin: 0 auto;
        cursor: pointer;
        font-family: "SourceHanSerifCN-Medium";
    }
    .content{
        width:100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 60px;
        align-items: center;
        .left{
            width:63%;
            display: flex;
            flex-direction: row;
            box-shadow:8px 14px 38px 0px rgba(0, 0, 0, 0.1);
            align-items: center;
            cursor: pointer;
            position: relative;
            img{
                width:40%;
                display: block;
                object-fit: cover;
                height:100%;
            }
            .nInfo{
                width:60%;
                background-color: white;
                p{
                    width:80%;
                    margin-left: 10%;
                }
                p:nth-child(1){
                    color:#999999;
                    font-family: "SourceHanSerifCN-Medium";
                }
                p:nth-child(2){
                    color:#333333;
                    font-size: 18px;
                    font-family: "SourceHanSerifCN-Medium";
                    margin: 30px auto;
                }
                p:nth-child(3){
                    color:#999999;
                    font-family: "SourceHanSerifCN-Medium";
                    line-height: 34px;
                    font-size: 14px;
                }
            }
            .add{
                width:47px;
                background:rgba(51,49,55,1);
                position: absolute;
                top:0;
                height:100%;
                transform: translateX(0);
                transition: all 600ms;
                opacity: 0;
            }
            &:hover{
                .add{
                    transform: translateX(-40px);
                    opacity: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    i{
                        color:white;
                    }
                }
            }
        }
        .r{
            width:30%;
            .one{
                width:100%;
                position: relative;
                cursor: pointer;
                img{
                    width:100%;
                    object-fit: cover;
                    display: block;
                }
                .ocon{
                    width:100%;
                    position: absolute;
                    left:0;
                    top:0;
                    background:rgba(49,47,47,.7);
                    height:100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    p{
                        text-align: center;
                        color:white;
                        font-family: "SourceHanSerifCN-Medium";
                        font-size: 14px;
                        line-height: 35px;
                    }
                    p:nth-child(2){
                        font-size: 16px;
                    }
                }
                .add{
                    width:47px;
                    background:rgba(51,49,55,1);
                    position: absolute;
                    top:0;
                    height:100%;
                    transform: translateX(0);
                    transition: all 600ms;
                    opacity: 0;
                }
                &:hover{
                    .add{
                        transform: translateX(-40px);
                        opacity: 1;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        i{
                            color:white;
                        }
                    }
                }
            }
            .one:nth-of-type(2){
                margin: 15px 0;
            }
        }
    }
    @media screen and (max-width: 1440px){
        width:90%;
    }
    @media screen and (max-width: 1000px){
        .title{
            width:100px;
            height:90px;
            line-height: 90px;
        }
        .content{
            flex-direction: column;
            // .one{
            //     .ocon{
            //         p{
            //             width:90%;
            //             margin: 0 auto;
            //         }
            //     }
            // }
            .left{
                flex-direction: column;
                img{
                    width:100%;
                    height:200px;
                }
                .nInfo{
                    width:100%;
                    margin: 15px auto;
                    p{
                        width: 90%;
                    }
                    p:nth-child(2){
                        font-size: 14px;
                    }
                    p:nth-child(1),p:nth-child(3){
                        margin: 0 auto;
                    }
                }
                &:hover{
                    .add{
                        display: none;
                    }
                }
            }
            .left,.r{
                width:100%;
            }
            .r{
                display: none;
                margin-top: 30px;
                .one{
                    &:hover{
                        .add{
                            display: none;
                        }
                    }
                }
            }
        }
    }
}
</style>
